import Span from 'src/components/atomic/atom/Span'
import Button from 'src/components/atomic/atom/Button'
import ExplorerHeader from 'src/components/atomic/organisms/views/Explorer/ExplorerHeader'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { ExplorerDeleteDataPropsType } from 'src/views/Service/Explorer/Delete'
import { ColorHandler } from 'src/utils/style.utils'
import ExplorerDeleteContents from 'src/components/atomic/organisms/views/Explorer/Delete/ExplorerDeleteContents'
import ExplorerDeleteBackupData from 'src/components/atomic/organisms/views/Explorer/Delete/ExplorerDeleteBackupData'

const ExplorerDeleteTemplate = (props: { data: ExplorerDeleteDataPropsType }) => {
  const { isAllCheckBoxesChecked, handleFileDelete } = props.data
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()

  return (
    <>
      <ExplorerHeader
        text={t('EXPLORER.GO_DELETE', { defaultValue: 'Delete Data' })}
        $margin={'35px auto 14px auto'}
      />
      <Span
        option={'title'}
        $margin={setMediaStyle('14px 0 4px 0', '16px 0 4px 0', '16px 0 4px 0')}
      >
        {t('EXPLORER.DELETE.TITLE', {
          defaultValue: 'Back up all of your data before you delete them!',
        })}
      </Span>
      <Span
        option={setMediaStyle('tiny', 'mini', 'mini')}
        color={COLOR.black70}
        $text_align={'left'}
      >
        {t('EXPLORER.DELETE.DESC', {
          defaultValue:
            'No deletion of data can be undone on your device. Make sure you have properly backed up the data you are about to delete.',
        })}
      </Span>
      <ExplorerDeleteBackupData />
      <Span
        option={setMediaStyle('tiny', 'mini', 'mini')}
        color={COLOR.black70}
        $text_align={'left'}
      >
        {t('EXPLORER.DELETE.TERMS.TITLE', {
          defaultValue: 'Check before you delete your data on your device that you.',
        })}
      </Span>
      <ExplorerDeleteContents data={props.data} />
      <Button
        $bgColor={ColorHandler(isAllCheckBoxesChecked, 'brand_black10')}
        $border_radius={setMediaStyle('12px', '100px', '100px')}
        $padding={'13px 14px'}
        onClick={handleFileDelete}
        disabled={!isAllCheckBoxesChecked}
        className="explorer_delete_ok"
      >
        <Span
          color={ColorHandler(isAllCheckBoxesChecked, 'white_black30')}
          option={setMediaStyle('medium_bold', 'small_bold', 'small_bold')}
        >
          {t('BUTTON.FILE_DELETE', { defaultValue: 'I Understand and Would Like to Proceed' })}
        </Span>
      </Button>
    </>
  )
}
export default ExplorerDeleteTemplate
